/**
 * Created by claudio iozzia on 04/07/2017.
 */
/**
 * Created by claudio iozzia on 04/07/2017.
 */
import {Validator_DcDc_BuckBoost} from "./dcdc_buck_boost_validator";
import {Ic, IEntityAlert} from "../../../../models/common";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Utils} from "../../../../common/utils";
import {EntityError} from "../../../../models/EntityAlert";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";

export class Validator_DcDc_798xPositiveBuckBoost extends Validator_DcDc_BuckBoost {

  private validatorFn_SingleOutput_Voltage_798xPositiveBuckBoost: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vOut = spec.spec.value.output.outputs[o].voltage;

    const vOutLowerBound: number = a.vout_min;
    const vOutUpperBound: number = a.vout_max;

    const result = Utils.acceptInRange(_vOut, vOutLowerBound, vOutUpperBound, "Vout", "V");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_798xPositiveBuckBoost: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vin = spec.spec.value.input;
    const _vOut = spec.spec.value.output.outputs[o];
    const isAttendibileVinMin: Boolean = !spec.spec.note.input.min.hasError && isFinite(_vin.min);
    const isFiniteVout: boolean = Utils.isValueReal(_vOut.voltage);
    let maxIout: number = ic.iout_max;
    if (isAttendibileVinMin && isFiniteVout) {
      const idealDuty: number = _vOut.voltage / (_vOut.voltage + _vin.min);
      const maxIoutForDuty: number = ValueFormatter.scale(maxIout * (1 - idealDuty), siPrefix.unit);
      maxIout = Math.min(maxIout, maxIoutForDuty);
    }
    const result = Utils.acceptUpTo(_vOut.current, maxIout, "Iout", "A");
    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_798xPositiveBuckBoost];
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_798xPositiveBuckBoost];
  }

}
